
let React = require("react");

export class AsyncLoader {

    private static RootPath;
    public static GetLazyComponent<T extends LoadableLibrary>(webpackRequire:any,importStatement:()=>Promise<T>): T['default']
    {
        webpackRequire.p=AsyncLoader.RootPath;
        return React.lazy(importStatement);
    }


    public static async GetLibrary<T extends LoadableLibrary>(webpackRequire:any,importStatement:()=>Promise<T>): Promise<T>
    {
        webpackRequire.p=AsyncLoader.RootPath;
        return importStatement();
    }

    public static SetRootPath(path:string){
        AsyncLoader.RootPath=path;
    }

}

interface LoadableLibrary {
    default:any;
}